<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headers"
        :items="usuarios"
        sort-by="calories"
        :search="search"
        class="elevation-1"
        >
        <template v-slot:item.activo="{ item }">  
            <div v-if="item.activo">
                <span class="blue--text">Activo</span>
                
            </div>
            <div v-else>
                <span class="red--text">Inactivo</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Usuarios</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                    </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field v-model="login" label="Login"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field v-model="nombre" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="apellido" label="Apellido"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select v-on:change="mostrar()" v-model="idrol" :items="roles" label="Rol">
                                    </v-select>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select :items="customer" v-model="idcliente" label="Cliente" ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field v-model="Telefono_p" label="Telefono Personal"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field v-model="Celular_p" label="Celular Personal"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field  v-model="ext" label="Ext"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field  v-model="email_p" label="E-mail Personal"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field  v-model="email_ogl" label="E-mail Optima"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field  v-model="passwordemailogl" label="Password mail optima"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field type="password" v-model="password" label="Password"></v-text-field>
                                </v-col>                                
                                <v-col cols="12" sm="12" md="12" v-show="valida">
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                                </v-col>                                                        
                            </v-row>
                        </v-container>
                    </v-card-text>    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog  v-model="adModal" max-width="290px">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item?</v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item?</v-card-title>
                        <v-card-text>
                            Estás a punto de
                            <span v-if="adAccion==1">Activar</span>
                            <span v-if="adAccion==2">Desactivar</span>
                            el item {{ adNombre }}
                        </v-card-text>
                        <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                 Cancelar
                             </v-btn>
                             <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                 Aceptar
                             </v-btn>
                             <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                 Desactivar
                             </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.opciones="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            edit
            </v-icon>
            <template v-if="item.activo">                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(2,item)"
                    >
                    block
                    </v-icon>                               
            </template>
            <template v-else>                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(1,item)"
                    >
                    check
                    </v-icon>                               
            </template> 
        </template>   
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
  </v-layout>
</template>


<script>
import axios from 'axios'      
export default {
    data(){
        return{
            usuarios:[], 
             adModal:false,            
             dialog: false,
                headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },                        
                { text: 'Nombre', value: 'nombre' },
                { text: 'Apellido', value: 'apellido' },   
                { text: 'Telefono Personal', value: 'Telefono_p', sortable: false  },                       
                { text: 'Celular Personal', value: 'Celular_P', sortable: false  },
                { text: 'Ext', value: 'ext', sortable: false  },
                { text: 'Email Personal', value: 'email_p', sortable: false  },
                { text: 'Email Empresarial', value: 'email_ogl', sortable: false  },                
                { text: 'Estado', value: 'activo', sortable: false  },                                
                ],
                search:'',
                editedIndex: -1,              
                id:'',
                idrol:'',                
                roles:[
                ],
                nombre:'',
                login:'',
                passwordemail:'',
                Telefono_p:'',
                Celular_P:'',
                ext:'',
                email_p:'',
                email_ogl:'',
                apellido:'',                
                direccion:'',
                telefono:'',
                email:'',
                password:'',
                actpassword:false,
                passwordAnt:'',
                idcategoria:'',
                idarticulo:'',
                categorias:[],
                codigo:'',
                nombre:'',
                stock:0,
                precio_venta:0,
                descripcion:'',                
                valida:'',
                validaMensaje:[],                
                adAccion:0,
                adNombre:'',
                adId:'',
                passwordemailogl:'',
                Celular_p:'',
                customer:[],
                idcliente:0,
                
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'Nueva Usuario' : 'Actualizar Usuario'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },

    created () {        
        this.listar();
        this.select();
    },
    methods:{        
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Usuarios/Listar',configuracion).then(function(response){
              //console.log(response);
              me.usuarios=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){
            var customerArray = [];
            //mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var rolesarray=[];
            axios.get('api/Roles/Select',configuracion).then(function(response){
              //console.log(response);
              rolesarray=response.data;
              rolesarray.map(function(x){
                  me.roles.push({text:x.nombre,value:x.idrol_usuario});
              });            
            }).catch(function(error){
              console.log(error);
            });
            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                customerArray=response.data;
                customerArray.map(function(x){
                    me.customer.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },

        editItem (item) {
            console.log('item')
            console.log(item)
            this.id = item.idusuario;            
            this.idrol = item.idrol_usuario;
            this.login = item.login;
            this.nombre = item.nombre;
            this.apellido = item.apellido;
            this.tipo_documento =item.tipo_documento;
            this.num_documento =item.num_documento;
            this.direccion = item.direccion;
            this.telefono = item.telefono;
            this.email_p = item.email_p;
            this.email_ogl = item.email_ogl;
            this.ext = item.ext;
            this.password = item.password_hash;
            this.passwordAnt = item.password_hash;
            this.editedIndex  = 1;
            this.dialog = true
        },
       
        mostrar(){
            console.log('entra')
            console.log(this.idrol)
            if(this.idrol == 1011){
                console.log('mostrar')
            }
        },
        close () {
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.id="";
            this.idrol="";
            this.nombre="";
            this.tipo_documento="";
            this.num_documento="";
            this.direccion="";
            this.telefono="";
            this.email="";
            this.password="";
            this.passwordAnt="";
            this.actpassword=false;
            this.editedIndex=-1;
        },
        guardar () {
            if(this.validar()){
                return;
            }
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if (this.editedIndex > -1) {//codigo para editar
                let me=this;

                //if(me.password != me.passwordAnt){
                    me.actpassword = true;
                //}
                axios.put('api/Usuarios/Actualizar',{
                    'idusuario':me.id,
                    'idrol_usuario':me.idrol,
                    'nombre':me.nombre,
                    'login':me.login,
                    'apellido':me.apellido,
                    'Telefono_p':me.Telefono_p,
                    'Celular_p':me.Celular_p,
                    'ext':me.ext,
                    'email_p':me.email_p,
                    'email_ogl':me.email_ogl,
                    'password':me.password,
                    'passwordemail':me.passwordemailogl,
                    'id_cliente':me.idcliente,
                    'id_consignatario':0,
                    'act_password':1
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });  
            } else {//codigo para guardar
                let me=this;
                axios.post('api/Usuarios/Crear',{
                    'idrol_usuario':me.idrol,
                    'nombre':me.nombre,
                    'login':me.login,
                    'apellido':me.apellido,
                    'Telefono_p':me.Telefono_p,
                    'Celular_p':me.Celular_p,
                    'ext':me.ext,
                    'email_p':me.email_p,
                    'email_ogl':me.email_ogl,
                    'password':me.password,
                    'passwordemail':me.passwordemailogl,
                    'id_cliente':me.idcliente,
                    'id_consignatario':0,
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];

            if(this.nombre.length<3 || this.nombre.length>100){
                this.validaMensaje.push("El nombre debe tener mas de 3 caracteres y menos de 100 caracteres.");
            }
            if(!this.idrol){
                this.validaMensaje.push("Seleccione un rol.");
            }
            if(!this.email){
                this.validaMensaje.push("Ingresa el email del usuario.");
            }
            if(!this.password){
                this.validaMensaje.push("Ingresa un password.");
            }
            return this.valida;
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idusuario;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Usuarios/Activar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Usuarios/Desactivar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>